document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('[js-mob-menu-item]');
  
  menuItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      menuItems.forEach(function(mi) {
        mi.classList.remove('active');
      });
      
      this.classList.add('active');
      
      var childMenu = this.querySelector('[js-mob-child-menu]');
      if (childMenu) {
        e.preventDefault();
      }
    });
  });
});